<template>
    <div>
        <b-button 
            variant="outline-primary"
            class="mb-2"
            size="sm"
            @click="addRow"
        >
            <i class="fa fa-fw fa-plus"></i>
            {{ trans('add_row') }}
        </b-button>
        <b-button 
            class="mb-2 ml-2"
            variant="outline-primary"
            size="sm"
            @click="addCol"
            v-if="!hideColBtn"
        >
            <i class="fa fa-fw fa-plus"></i>
            {{ trans('add_column') }}
        </b-button>
        <slot></slot> 

        <hot-table 
            ref="hotTable"
            :language="lang"
            :settings="{
                data: json,
                licenseKey: 'non-commercial-and-evaluation',
                colHeaders: this.col ? this.col : true,
                rowHeaders: true,
                customBorders: true,
                dropdownMenu: true,
                multiColumnSorting: true,
                filters: true,
                manualRowMove: true,
                contextMenu: true,
                autoWrapRow: true,
                autoWrapCol: true,
                afterChange: (data) => {
                    // if loadsource data is null
                    if (this.hotRef && data) {
                        this.$emit('input', this.hotRef.getSourceData())
                    }
                },
                ...params
            }"
        ></hot-table>
    </div>
  </template>
  
  <script>
    import { HotTable } from '@handsontable/vue';
    import {
        registerLanguageDictionary,
        getLanguagesDictionaries,
        frFR,
    } from 'handsontable/i18n';
    import { registerAllModules } from 'handsontable/registry';
    import 'handsontable/dist/handsontable.full.css';
    
    registerAllModules();

    if (window.lang == 'fr') {
        registerLanguageDictionary(frFR);
    }
  
    export default {
      props: {
        value: Array,
        params: Object,
        col: Array,
        hideColBtn: {
            type: Boolean,
            default: false,
        }
      },
      components: {
        HotTable
      },
      data() {
        return {
          trans: trans,
          json: this.value ? this.value : [['', '', '', '', '', '', '', '', '', ''], ['', '', '', '', '', '', ''], ['', '', '', '', '', '', ''], ['', '', '', '', '', '', '']],
          hotRef: null,
          lang: window.lang == 'fr' ? 'fr-FR' : 'en-US',
        }
      },
      computed: {
        
      },
      methods: {
        addRow() {
            this.hotRef.alter('insert_row_below')
        },
        addCol() {
            this.hotRef.alter('insert_col_end')
        },
      },
      watch: {
        value() {
            this.json = this.value
            this.hotRef.loadData(this.json)
        },
      },
      mounted() {
        window.exelTable = this
        this.hotRef = this.$refs.hotTable.hotInstance
      },
    }
  </script>